// The WEB Argon2id provider (identity/kdf.ts `Argon2idProvider`), backed by
// hash-wasm. This is the ONE module that imports hash-wasm; it is imported only
// by web/shell call sites (screens, onboarding, the Capacitor bridge, tests).
// The headless brain never imports it — it injects the native Argon2id seam
// instead — which is exactly why the WASM lives here and not in kdf.ts, keeping
// the brain bundle WASM-free (ios/BOUNDARY.md §2.6, build:brain assertion).

import { argon2id } from 'hash-wasm';
import type { Argon2idProvider } from '@merkury/brain/identity/kdf.js';

/** hash-wasm Argon2id, adapting the injected-provider request to its options. */
export const webArgon2id: Argon2idProvider = (req) =>
  argon2id({
    password: req.password,
    salt: req.salt,
    memorySize: req.memoryKiB,
    iterations: req.iterations,
    parallelism: req.parallelism,
    hashLength: req.hashLength,
    outputType: 'binary',
  });
